import clsx from "clsx";

import { Breadcrumbs } from "@features/navigations/breadcrumbs";

import { Body } from "@shared/ui/typography";
import { Heading } from "@shared/ui/typography/heading";
import { mod } from "@shared/utils";

import type { PageHeroSecondaryProps } from "../../types";

import s from "./page-hero-secondary.module.scss";

export const PageHeroSecondary = ({
  title,
  updatedAt,
  textColor = "milk",
  className,
  breadcrumbs,
  viewUpdatedAt,
}: PageHeroSecondaryProps) => {
  const mods = mod(s, {
    color: textColor,
  });
  return (
    <section className={clsx(s.root, mods, className)}>
      {breadcrumbs && breadcrumbs?.length > 0 && (
        <Breadcrumbs className={s.breadcrumbs} items={breadcrumbs} />
      )}
      <div className={s.content}>
        {title && (
          <Heading level={3} tag="h1" className={s.title}>
            {title}
          </Heading>
        )}
        {viewUpdatedAt && updatedAt && (
          <Body size="uppercase" weight="semiBold" className={s.updatedAt}>
            {updatedAt}
          </Body>
        )}
      </div>
    </section>
  );
};
